import { classnames } from '@/helpers';
import { customTwMerge } from '@/helpers/theme';

export const SYMBOL_SIZE = {
  xs: 'w-[20px] h-[20px]',
  sm: 'w-[32px] h-[32px]',
  md: 'w-[48px] h-[48px]',
  lg: 'w-[64px] h-[64px]',
  '56': 'h-[56px] w-[56px]',
  '60': 'h-[60px] w-[60px]',
  '64': 'h-[64px] w-[64px]',
  '72': 'h-[72px] w-[72px]',
  '80': 'h-[80px] w-[80px]',
  '96': 'h-[96px] w-[96px]',
};

type SymbolProps = {
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | '56' | '60' | '64' | '72' | '80' | '96';
  classNames?: string;
};

const initialFontSize: Record<'xs' | 'sm' | 'md' | 'lg' | '56' | '60' | '64' | '72' | '80' | '96', string> = {
  xs: 'text-xs',
  sm: 'text-s',
  md: 'text-l',
  lg: 'text-xl',
  '56': 'text-2xl',
  '60': 'text-2xl',
  '64': 'text-2xl',
  '72': 'text-2xl',
  '80': 'text-2xl',
  '96': 'text-2xl',
};

const Symbol = ({ children, size = 'md', classNames }: SymbolProps) => {
  return (
    <div className="relative inline-block">
      <div
        className={customTwMerge(
          classnames(
            'bg-bg_secondary text-fg_secondary p-2xs relative flex items-center justify-center overflow-hidden rounded-sm',
            {
              [SYMBOL_SIZE[size]]: !!SYMBOL_SIZE[size],
              [classNames]: !!classNames,
            },
          ),
        )}>
        <span className={classnames(initialFontSize[size])}>{children}</span>
      </div>
    </div>
  );
};

export default Symbol;
